import React from 'react';
import '../index.css';

const NotFound = () => (
  <div className="not-found">
    <h1>404</h1>
    <h2>Page not found</h2>
    <p>We're fairly sure that page used to be here, but it seems to have gone missing.</p>
    <a className="btn-home" href="/">Back home</a>
  </div>
);

export default NotFound;
